import { IArticle, ICategory } from '@/types'
import { API_BASEPATH } from '.'

type Response = {
  data: IArticle[]
  meta: {
    pagination: {
      page: number
      pageCount: number
      pageSize: number
      total: number
    }
  }
}

export const getArticles = async (query?: string) => {
  const response = await fetch(`${API_BASEPATH}/api/articles?${query}`)
  const data = await response.json()
  return data as Response
}

export const getArticle = async (id: number, query?: string) => {
  const response = await fetch(`${API_BASEPATH}/api/articles/${id}?${query}`)
  const data = await response.json()
  return data as { data: IArticle }
}

export const getCategories = async (query?: string) => {
  const response = await fetch(`${API_BASEPATH}/api/categories?${query}`)
  const data = await response.json()
  return data as { data: ICategory[] }
}
